export default __webpack_public_path__ + "static/media/logo_ctag_white.a66c82a7.png";